import useDate from '@/services/utils/day';

const pdfHeaderFooter = () => {
    const { formatDate } = useDate();

    const validValue = (value) => {
        if (! value) return ''
        if (value === 'null') return ''
        if (value === 'undefined') return ''
        return value
    }

    const getHeader = (company) => {
        const name = validValue(company.name);
        const address = validValue(company.address);
        const phone = validValue(company.phone);
        const email = validValue(company.email);
        const vatNo = validValue(company.vat_no);

        return {
            margin: [ 25, 25, 25, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        name,
                        address ? 'Address: ' + address : '',
                        phone ? 'Phone: ' + phone : '',
                        email ? 'E-mail: ' + email : '',
                        vatNo ? 'VAT Reg No: ' + vatNo : '',
                    ]
                }
            ]
        }
    }

    const getFooter = (userName, qrcode) => {
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            svg: qrcode
                        },

                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    return {
        getHeader, 
        getFooter
    }
}

export default pdfHeaderFooter;
